import React, { createContext, useContext, useState, useCallback } from 'react';

// Pages register the sidebar nav from inside their effects. `sections`
// is an array of:
//   {
//     heading: 'Inspection Standard',
//     activeKey: 'eemua159',
//     items: [
//       { key: 'eemua159', label: 'EEMUA 159' },
//       { key: 'api653',   label: 'API 653',   placeholder: true },
//     ],
//     onSelect: (key) => { ... }
//   }
//
// AnalysisLayout reads `sections` and renders them in its left rail.

const SidebarContext = createContext({
  sections: [],
  setSidebar: () => {},
  clearSidebar: () => {},
});

export function AnalysisSidebarProvider({ children }) {
  const [sections, setSections] = useState([]);

  const setSidebar = useCallback((next) => setSections(Array.isArray(next) ? next : []), []);
  const clearSidebar = useCallback(() => setSections([]), []);

  return (
    <SidebarContext.Provider value={{ sections, setSidebar, clearSidebar }}>
      {children}
    </SidebarContext.Provider>
  );
}

export function useAnalysisSidebar() {
  return useContext(SidebarContext);
}
